<template>
  <div>
    <my-header></my-header>

    <div v-if="plotly">
    <Plotly :data="plotly" :layout="layout" :display-mode-bar="false"></Plotly>
    </div>

  </div>
</template>

<script>
import MyHeader from './Header.vue';
import { HTTP } from '../http-common';
import { Plotly } from 'vue-plotly';
import notifier from '../notifier';

export default {
  components: { MyHeader, Plotly },
  created: function() {
    HTTP.get('/dashboard')
     .then(response => {
       this.plotly = [
        {
          type: "indicator",
          title: { text: "Online(last 15m)" },
          value: response.data.online,
          mode: "number+gauge",
          delta: { reference: 0 },
          gauge: { axis: { visible: false, range: [0, 5000] } }
        },
        {
          type: "indicator",
          title: { text: "DAU(vs day ago)" },
          mode: "number+delta",
          value: response.data.dau,
          domain: { row: 0, column: 1 },
          delta: { reference: response.data.dau_day_ago }
        },
        {
          type: "indicator",
          title: { text: "Day Installs(vs day ago)" },
          mode: "number+delta",
          value: response.data.installs,
          domain: { row: 1, column: 0 },
          delta: { reference: response.data.installs_day_ago }
        },
        {
          type: "indicator",
          title: { text: "Day IAPs(vs day ago)" },
          mode: "number+delta",
          value: response.data.day_iaps,
          domain: { row: 1, column: 1 },
          delta: { reference: response.data.day_iaps_day_ago }
        }
       ]
     })
    .catch(e => {
      notifier.showError(e.response.data, {sender: this});
    })
    .finally(() => {
    });
  },

  data () {
    return {
      plotly: null,
      layout: {
        width: 600,
        height: 400,
        margin: { t: 50, b: 25, l: 25, r: 25 },
        grid: { rows: 2, columns: 2, pattern: "independent" }
      }
    }
  },
}
</script>
